import { ActivityFeed } from '@modules/_shared/components/feed-v2/ActivityFeed';
import { LeadSummary } from '@modules/_shared/components/feed-v2/components/LeadSummary';
import { useAppData } from '@modules/_shared/providers/AppDataProvider';
import { LEAD_FEED } from '@modules/leads/leadsQueries';
import { isRATenantId } from '@shared/utils/tenant';

type LeadFeedV2Props = {
  lead_id: string;
  canView?: boolean;
  scrollParentRef: React.RefObject<HTMLElement | null>;
};

const LeadFeedV2 = ({
  lead_id,
  canView = true,
  scrollParentRef,
}: LeadFeedV2Props) => {
  const { me } = useAppData();

  return (
    <ActivityFeed
      parentType="Lead"
      parentId={lead_id}
      primaryLeadId={lead_id}
      disabled={!canView}
      query={LEAD_FEED}
      variables={{ lead_id }}
      scrollParent={scrollParentRef.current}
      header={
        canView &&
        me?.is_admin &&
        me?.tenant_id &&
        isRATenantId(me.tenant_id) ? (
          <LeadSummary key={lead_id} leadId={lead_id} />
        ) : undefined
      }
    />
  );
};

export default LeadFeedV2;
